export const TRANSACTION_STATUS = {
  IS_PENDING: 'isPending',
  IS_CONFIRMING: 'isConfirming',
  IS_SUCCESS: 'isSuccess',
  IS_ERROR: 'isError',
}
